import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  IconButton,
  Button,
  Grid,
  Paper,
  Chip,
  MenuItem,
  Tooltip,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch, useSelector } from "react-redux";
import { deleteEvent, setEditingEvent } from "../../Redux/Slices/eventsSlice";
import { AllTypoFontStyles, EventManagementStyles } from "../../Styles/styles";
import {
  EventsManageIcon,
  UpcomingEventsIcon,
  VisibilityOnIcon,
  VisibilityOffIcon,
  EditContentIcon,
  DeleteContentIcon,
  SearchIcn,
} from "../../Svg/icons";
import { DatePicker, Input, notification, Select, Table } from "antd";
import EventDetails from "../../components/MyEvents/EventManagementMain/EventDetails/EventDetails";
import {
  useGetEventsQuery,
  useGetProfileInformationQuery,
} from "../../Redux/apis/ApiSlice";
import { useDeleteEventMutation } from "../../Redux/apis/ApiSlice";
import {
  clearEditEventInfo,
  setEditEventInfo,
} from "../../Redux/Slices/editEventInfoSlice";
import {
  clearEditTicket,
  setEditEvent,
  setEditTicket,
} from "../../Redux/Slices/editTicketSlice";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import {
  clearTicketPayload,
  setTicketPayload,
} from "../../Redux/Slices/ticketPayloadSlice";
import moment from "moment";
import AddYourEventButton from "../../components/HomeLandingPage/Search/AddYourEventButton";
import Loader from "../../components/Loader/Loader";
export default function EventManagementMain() {
  const { Option } = Select;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const events = useSelector((state) => state?.events?.events);
  const [eventsList, setEventsList] = useState([]);
  // State for filters
  const [eventName, setEventName] = useState("");
  const [organizerName, setOrganizerName] = useState("");
  const [status, setStatus] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [visibleEventId, setVisibleEventId] = useState(null);
  const [onBoarding, setOnboarding] = React.useState();
  const { data: profileData, refetch: fetchProfileData } =
    useGetProfileInformationQuery();

  const {
    data: allEvents,
    error,
    isLoading,
    refetch,
  } = useGetEventsQuery({
    eventName,
    organizerName,
    status,
    startDate: startDate ? startDate.toISOString() : undefined,
    endDate: endDate ? endDate.toISOString() : undefined,
  });

  useEffect(() => {
    refetch();
  }, [refetch]);
  const [deleteEvent] = useDeleteEventMutation();

  const data = [
    {
      title: "Active Events",
      value: allEvents?.liveEventsCount,
      icon: <EventsManageIcon />,
    },
    {
      title: "Upcoming Events",
      value: allEvents?.upcomingEventsCount,
      icon: <EventsManageIcon />,
    },
    {
      title: `Up Next`,
      value: allEvents?.nextUpcomingEvent || "",
      icon: <UpcomingEventsIcon />,
    },
  ];
  const statusOptions = [
    { value: "upcoming", label: "Upcoming" },
    { value: "live", label: "Live" },
    { value: "finish", label: "Finish" },
  ];

  const userData = JSON.parse(localStorage.getItem("userData"));

  const handleDeleteEvent = async (eventId) => {
    const userId = userData.id;
    try {
      await deleteEvent({ eventId, userId }).unwrap();
      notification.success({ message: "Event deleted successfully!" });
      refetch();
    } catch (error) {
      if (
        error.data.error ===
        'update or delete on table "events" violates foreign key constraint "NewTickets_event_id_fkey" on table "NewTickets"'
      ) {
        notification.error({ message: "Event already booked by attendees!" });
        return;
      }
      console.error("Failed to delete event", error.data);
    }
  };

  const handleToggleVisibility = (id) => {
    setVisibleEventId((prevId) => (prevId === id ? null : id));
  };

  const handleEditEvent = (event) => {
    dispatch(clearEditTicket());
    if (allEvents?.events) {
      const eventDetails = allEvents.events.find(
        (e) => e.event.eventId === event.id
      );

      if (eventDetails) {
        const ticket = eventDetails.event.ticket[0];

        // Dispatch event details to Redux store
        dispatch(setEditEventInfo(eventDetails));
        if (eventDetails.event.ticket[0]) {
          dispatch(setEditTicket(ticket.ticketId));
        }
        const tax =
          eventDetails.event.tax === true ? "Participants" : "Company";
        // Prepare payload for ticket details
        const ticketPayload = {
          eventId: eventDetails.event.eventId,
          feeDeduction: tax,
          ticketId: ticket?.ticketId,
          ticketCategory: ticket?.ticketCategory,
          color: ticket?.color,
          code: ticket?.code,
          ticketTemplate: ticket?.ticketTemplate,
          ticketPhoto: ticket?.ticketPhoto,
          ticketType: ticket?.subTickets.map((subTicket) => ({
            ticketTypeId: subTicket.ticketType.ticketTypeId, // Correct field for matching
            quantity: subTicket.quantity,
            price: subTicket.price,
            ticketTypeName: subTicket.ticketType.typeName,
          })),
        };

        // Dispatch the ticket payload to Redux
        dispatch(setTicketPayload(ticketPayload));

        // Navigate to the 'add-event' screen
        navigate("/add-event");
      }
    }

    // Dispatch the editing event to Redux
    dispatch(setEditingEvent(event));
  };

  const renderStatusChip = (status) => {
    let color;
    let label;
    let backgroundColor;

    switch (status) {
      case "upcoming":
        color = "purple";
        backgroundColor = "rgba(128, 0, 128, 0.1)";
        label = "Upcoming";
        break;
      case "Upcoming":
        color = "purple";
        backgroundColor = "rgba(128, 0, 128, 0.1)";
        label = "Upcoming";
        break;
      case "live":
        color = "red";
        backgroundColor = "rgba(250, 0, 0, 0.1)";
        label = "Live";
        break;
      case "Live":
        color = "red";
        backgroundColor = "rgba(250, 0, 0, 0.1)";
        label = "Live";
        break;
      case "finish":
        color = "green";
        backgroundColor = "rgba(0, 128, 0, 0.1)";
        label = "Finish";
        break;
      case "Finish":
        color = "green";
        backgroundColor = "rgba(0, 128, 0, 0.1)";
        label = "Finish";
        break;
      default:
        color = "grey";
        backgroundColor = "rgba(128, 128, 128, 0.1)";
        label = status;
    }

    return (
      <Chip
        icon={
          <svg
            width="5"
            height="6"
            viewBox="0 0 5 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="2.5" cy="3" r="2.5" fill={color} />
          </svg>
        }
        size="small"
        label={label}
        sx={{
          color: color,
          backgroundColor: "transparent",
          fontWeight: 500,
          fontSize: "12px",
          height: "22px",
          justifyContent: "left",
          // gap: 2,
          // padding: 1,
          width: "100%",
          borderRadius: "4px",
        }}
      />
    );
  };
  const columns = [
    {
      dataIndex: "name",
      title: "Event Name",
      key: "name",
      width: 200,
      ellipsis: true,
    },
    {
      dataIndex: "startDateTime",
      title: "Start Date",
      key: "startDateTime",
      width: 120,
    },
    {
      dataIndex: "location",
      title: "Location",
      key: "location",
      width: 150,
      ellipsis: true,
    },
    {
      dataIndex: "totalTickets",
      title: "Total Tickets",
      key: "totalTickets",
      width: 100,
    },
    {
      dataIndex: "status",
      title: "Status",
      key: "status",
      width: 120,
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "center" }}>
          {record.completionStatus === "complete"
            ? renderStatusChip(record.status)
            : (
              <Chip
                icon={<svg width="5" height="6"><circle cx="2.5" cy="3" r="2.5" fill={"GrayText"} /></svg>}
                size="small"
                label={"Incomplete"}
                sx={{
                  color: "GrayText",
                  backgroundColor: "transparent",
                  fontWeight: 500,
                  fontSize: "12px",
                  height: "22px",
                  justifyContent: "left",
                  width: "100%",
                  borderRadius: "4px",
                }}
              />
            )}
        </div>
      ),
    },
    {
      dataIndex: "action",
      title: "Action",
      key: "action",
      width: 220,
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap", display: "flex", gap: "4px", alignItems: "center" }}>
          <Button
            onClick={() => handleToggleVisibility(record.id)}
            variant="text"
            size="small"
            sx={{
              textTransform: "none",
              fontSize: "12px",
              padding: "2px 8px",
              borderRadius: "8px",
              backgroundColor: visibleEventId === record.id ? "#f0f4ff" : "#f9f9f9",
              borderColor: "#c4c4c4",
              color: "#1976d2",
              "&:hover": {
                backgroundColor: "#e8f0fe",
                transform: "scale(1.05)",
                boxShadow: "0 0 6px rgba(25, 118, 210, 0.3)",
              },
            }}
          >
            {visibleEventId === record.id ? "Hide Details" : "Detail / Scan"}
          </Button>
  
          {record.roleId !== 2 && (
            <>
              <IconButton color="secondary" onClick={() => handleEditEvent(record)}>
                <EditContentIcon />
              </IconButton>
              <IconButton onClick={() => handleDeleteEvent(record.id)} style={{ color: "red" }}>
                <DeleteContentIcon />
              </IconButton>
            </>
          )}
        </div>
      ),
    },
  ];
  

  const selectedEvent = allEvents?.events?.find(
    (event) => event?.event?.eventId === visibleEventId
  );

  useEffect(() => {
    if (allEvents) {
      if (allEvents.events) {
        const transformedEvents = allEvents?.events?.map((item) => ({
          key: item?.event?.eventId,
          id: item?.event?.eventId,
          name: item?.event?.eventName,
          fullName: item?.user?.fullName,
          description: item?.event?.description,
          totalTickets: item?.event?.totalTickets || "0",
          eventId: item?.event?.eventId,
          date: moment(item?.event?.date).format("MM/DD/YYYY"),
          startDateTime: moment(item?.event?.startDateTime).format(
            "MM/DD/YYYY"
          ),
          location: item?.event?.location,
          status: item?.event?.status,
          roleId: item?.roleId,
          completionStatus: item?.event?.completionStatus,
        }));

        setEventsList(transformedEvents);
      } else {
        console.log("No events in response:", allEvents);
      }
    }
  }, [allEvents]);
  useEffect(() => {
    fetchProfileData(); // Force a refetch mount
  }, []);

  useEffect(() => {
    if (profileData) {
      setOnboarding(profileData.user.onBoarding);
    }
  }, [profileData]);

  const handleAddEventClick = () => {
    dispatch(clearEditTicket());
    dispatch(clearEditEventInfo());
    dispatch(clearTicketPayload());
    navigate("/add-event");
  };
  return (
    <>
      <Grid
        container
        sx={{ display: visibleEventId ? "none" : "block" }}
        md={visibleEventId ? 0 : 12}
        xs={12}
        p={1.5}
      >
        <Box>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              {data.map((item, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Paper
                    elevation={1}
                    sx={{
                      borderRadius: 3,
                      padding: 1.5,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: 125,
                    }}
                  >
                    <Typography sx={AllTypoFontStyles.CommonCardsTitleTypo}>
                      {item.title}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        // alignItems: "center",
                        justifyContent: "space-between",
                        alignItems: "flexStart",
                        mt: 1,
                        gap: 1,
                      }}
                    >
                      <Grid>{item.icon}</Grid>
                      <Typography
                        sx={{
                          ...AllTypoFontStyles.CommonCardsValueTypo,
                          fontSize: {
                            xs: "1rem",
                            md: index === 2 ? "1.3rem" : "1.8rem",
                          },
                        }}
                      >
                        <Tooltip title={item.value} arrow>
                          <div
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "230px",
                            }}
                          >
                            {item.value}
                          </div>
                        </Tooltip>
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>
          <Grid item md={visibleEventId ? 0 : 12} xs={12}>
            <Box p={2} mt={3}>
              <Typography
                gutterBottom
                sx={{
                  ...AllTypoFontStyles.CommonTypo1,
                  fontWeight: "bold",
                  mb: 2,
                }}
              >
                Manage Events
              </Typography>

              <Grid container spacing={2}>
                {/* Search Input */}
                <Grid item xs={12} sm={6} lg={3}>
                  <Input
                    prefix={<SearchIcn />}
                    size="large"
                    placeholder="Search Event Name"
                    sx={{ ...EventManagementStyles.SearchField, width: "100%" }}
                    value={eventName}
                    onChange={(e) => setEventName(e.target.value)}
                    fullWidth
                  />
                </Grid>

                {/* Status Filter - Fixing Full Width Issue */}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  lg={2}
                  sx={{ "& .ant-select": { width: "100%" } }}
                >
                  <Select
                    placeholder="Status"
                    size="large"
                    sx={{
                      ...EventManagementStyles.SearchField,
                      width: "100%", // Forces full width
                    }}
                    value={status}
                    onChange={(value) => setStatus(value)}
                    displayEmpty
                    fullWidth
                  >
                    <MenuItem value="">All Events</MenuItem>
                    {statusOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {renderStatusChip(option.value)}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {/* Start Date Picker - Fixing Full Width */}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  lg={2}
                  sx={{ "& .ant-picker": { width: "100%" } }}
                >
                  <DatePicker
                    placeholder="Select Start Date"
                    size="large"
                    sx={{
                      ...EventManagementStyles.SearchField,
                      width: "100%", // Ensures it takes full width
                    }}
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    format="MM/DD/YYYY"
                    fullWidth
                    inputReadOnly
                  />
                </Grid>

                {/* End Date Picker - Fixing Full Width */}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  lg={2}
                  sx={{ "& .ant-picker": { width: "100%" } }}
                >
                  <DatePicker
                    placeholder="Select End Date"
                    size="large"
                    sx={{
                      ...EventManagementStyles.SearchField,
                      width: "100%", // Ensures it takes full width
                    }}
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    format="MM/DD/YYYY"
                    fullWidth
                    inputReadOnly
                  />
                </Grid>

                {/* Add Event Button - Center on Mobile, Right on Large Screens */}
                <Grid
                  item
                  xs={12}
                  lg={3}
                  display="flex"
                  justifyContent="flex-end"
                >
                  <Button
                    startIcon={<AddIcon sx={{ color: "white" }} />}
                    onClick={handleAddEventClick}
                    sx={{
                      ...EventManagementStyles.AddEventBtn,
                      fontSize: { xs: "12px", sm: "14px" },
                      color: "white",
                      borderRadius: "4px",
                      backgroundColor: "var(--primary-color)",
                      "&:hover": { backgroundColor: "grey", color: "white" },
                      width: { xs: "140px", md: "180px", lg: "200px" },
                      padding: { xs: "6px 15px", sm: "8px 15px" },
                    }}
                  >
                    Add Event
                  </Button>
                </Grid>
              </Grid>
            </Box>

            <Grid sx={{ padding: 1 }} md={12}>
              <Box sx={EventManagementStyles.Box3}>
                {eventsList.length > 0 ? (
                  <Table
                    style={{ border: "none" }}
                    rowClassName={() => "custom-row"}
                    columns={columns}
                    dataSource={eventsList}
                    pagination={{ pageSize: 4 }}
                    scroll={{ y: 430, x: "max-content" }}
                  />
                ) : isLoading ? (
                  <Typography
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Loading...
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    No events
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      {visibleEventId && (
        <Grid container md={12} xs={12}>
          <EventDetails
            event={selectedEvent}
            setVisibleEventId={setVisibleEventId}
          />
        </Grid>
      )}
    </>
  );
}
